import { Rule } from 'antd/lib/form';
import { CB_PROMO_CODE_REGEX } from './constants';

export const formItemRules: Record<string, Rule[]> = {
  kind: [{ required: true, message: 'Please select the promo code type' }],
  code: [
    {
      pattern: CB_PROMO_CODE_REGEX,
      message: '4–32 characters of letters, numbers, "_" or "-"',
    },
  ],
  perAccountLimit: [
    { required: true, message: 'Please enter a per-account limit' },
    {
      type: 'number',
      min: 1,
      message: 'Per-account limit must be at least 1',
    },
  ],
  totalUses: [
    { required: true, message: 'Please enter the total number of uses' },
    { type: 'number', min: 1, message: 'Total uses must be greater than 0' },
  ],
  creditAmount: [
    { required: true, message: 'Please enter the credit amount' },
    {
      type: 'number',
      min: 0.01,
      message: 'Credit amount must be greater than 0',
    },
  ],
  matchPercent: [
    { required: true, message: 'Please enter the match percent' },
    {
      type: 'number',
      min: 0.01,
      message: 'Match percent must be greater than 0',
    },
  ],
  maxPromoPerRedemption: [
    { required: true, message: 'Please enter the per-redemption cap' },
    { type: 'number', min: 0.01, message: 'Cap must be greater than 0' },
  ],
  percentOff: [
    { required: true, message: 'Please enter the discount percent' },
    {
      type: 'number',
      min: 0.01,
      max: 100,
      message: 'Discount must be greater than 0 and at most 100',
    },
  ],
  duration: [
    { required: true, message: 'Please select the discount duration' },
  ],
  durationMonths: [
    { required: true, message: 'Please enter the number of months' },
    { type: 'number', min: 1, message: 'Months must be greater than 0' },
  ],
  trialDays: [
    { required: true, message: 'Please enter the number of trial days' },
    {
      type: 'number',
      min: 1,
      max: 730,
      message: 'Trial must be between 1 and 730 days',
    },
  ],
  note: [{ max: 2000, message: 'Note must be 2000 characters or fewer' }],
  applicableTargets: [
    { type: 'array', max: 20, message: 'At most 20 targets are allowed' },
  ],
};
